<template>

    <Head title="Reminder" />

    <div class="card card-outline card-primary">
        <div class="card-header">
            <h3 class="card-title">PENGINGAT SP SHM</h3>
            <div class="card-tools">
                <Link href="/home" class="btn btn-tool">
                <i class="fas fa-times"></i>
                </Link>
            </div>
        </div>
        <div class="card-body table-responsive">
            <data-table :columns="columns" :ajax="ajax" :order="[1, 'asc']"
                :columnDefs="[{ targets: [6, 7, 8], className: 'dt-body-center' }]"></data-table>
        </div>
    </div>
</template>

<script>
import Layout from '@/Layouts/Master'
import { Head, Link } from "@inertiajs/vue3"
import DataTable from '@/Forms/DataTable'

export default {
    layout: Layout,
    components: {
        Head,
        Link,
        DataTable
    },
    data() {
        return {
            columns: [
                { title: 'No', data: 'DT_RowIndex', orderable: false, searchable: false },
                { title: 'Tunggakan', data: 'tgl_tunggakan' },
                { title: 'Kantor', data: 'kantor' },
                { title: 'Rekening', data: 'rek' },
                { title: 'Nama', data: 'nama' },
                { title: 'Jaminan', data: 'jaminan' },
                { title: 'SP1', data: 'sp1' },
                { title: 'SP2', data: 'sp2' },
                { title: 'SP3', data: 'sp3' },
            ],
            ajax: {
                url: '/datatables/reminder',
            },
        }
    },
}   
</script>